import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import LogRocket from 'logrocket';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import { configService } from './service';
import './styles/app.css';
import theme from './theme';

// Logrocket
LogRocket.init(configService.appConfig.logRocketId, {
    network: {
        requestSanitizer: (request) => {
            // Do not log bearer token
            if (request.headers.Authorization) {
                request.headers.Authorization = request.headers.Authorization.replace(/Bearer\s.+/, 'Bearer [REDACTED]');
            }
            return request;
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <App />
    </ThemeProvider>
);
